export const APPS_ROUTES = {
  landing: '/a/',
} as const

/** AppMetrica serve-ссылки (landing badges + mobile redirect) */
export const APPMETRICA_SERVE = {
  apple: 'https://redirect.appmetrica.yandex.com/serve/818922990581394302',
  google: 'https://redirect.appmetrica.yandex.com/serve/170404690310291845',
  huawei: 'https://redirect.appmetrica.yandex.com/serve/821010311468352718',
} as const

export const DOWNLOAD_GTM_EVENTS = {
  storeApple: 'appstore-click',
  storeGoogle: 'googleplay-click',
  ctaMobile: 'appdown-mob',
} as const

export const APPS_LANDING_SEO = {
  title: 'Приложение для заказа вкусной еды от ресторана «Фарфор»',
  description:
    'Скачать приложение ресторана «Фарфор» для заказа вкусной еды с доставкой по России, Казахстану и Кыргызстану. Бесплатно для скачивания в AppStore, GooglePlay и AppGallery.',
} as const

export const APPS_SOCIAL_LINKS = [
  {
    key: 'vk',
    href: 'https://vk.com/farfordostavka',
  },
  {
    key: 'telegram',
    href: 'https://t.me/farfordostavkaTG',
  },
] as const
